



















































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import TrashCanOutlineIcon from 'vue-material-design-icons/TrashCanOutline.vue';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import CourseBoardCard from '@/components/cards/CourseBoardCard.vue';
import defaultBoardGroup from '@/helpers/courseBoardsGroupDefault';
import { BoardsGroupModel, GroupModel } from '@descomplica/dex-models';
import CourseAddBoardToGroupModal from '@/components/modals/course_boards_groups/AddBoardToGroup.vue';
import CourseCreateBoardsGroupModal from '@/components/modals/course_boards_groups/CreateBoardsGroupAndGroup.vue';

export default Vue.extend({
  components: {
    TrashCanOutlineIcon,
    SquareEditOutlineIcon,
    pxButton,
    CourseBoardCard,
    CourseAddBoardToGroupModal,
    CourseCreateBoardsGroupModal,
  },

  props: {
    course: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      showModal: false,
      name: null,
      description: null,
      managedEntity: null,
      managedEntityType: null,
      isEditing: false,
      addDefaultGroupLoading: false,
      entities: {
        BOARDS_GROUP: 'boardsGroup',
        GROUP: 'group',
      },
      boardToGroupStrategies: {
        NEW_BOARD: 'newBoard',
        EXISTING_BOARD: 'existingBoard',
      },
      grouplessBoardsToAdd: [],
      addBoardToGroup: {
        groupId: null,
        visible: false,
        boardsGroupId: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      boardsGroupsByCourseId: 'getBoardsGroupsByCourseId',
      getGroupsByBoardsGroupId: 'getGroupsByBoardsGroupId',
      getGroupById: 'getGroupById',
    }),
    boardsGroups() {
      return this.boardsGroupsByCourseId(this.course.id);
    },
    grouplessCourseBoardsByBoardsGroupId() {
      return this.boardsGroups.reduce((acc, boardsGroup) => {
        const boardsGroupBoardIds = boardsGroup.groups
          .map(group => group.boardIds)
          .flat();

        acc[boardsGroup.id] = this.course.courseBoardsByCourseId.nodes
          .filter(
            courseBoard => !boardsGroupBoardIds.includes(courseBoard.board.id),
          )
          .map(courseBoard => ({
            id: courseBoard.id,
            board: courseBoard.board,
          }));

        return acc;
      }, {});
    },
  },

  methods: {
    getGroupsFromBoardGroup(boardGroup: BoardsGroupModel | null) {
      if (!boardGroup) return [];
      return this.getGroupsByBoardsGroupId(boardGroup.id).sort(
        (A: GroupModel, B: GroupModel) => A.position - B.position,
      );
    },
    getBoardsInfo(boardsIds: number[]) {
      const boardsInfo = boardsIds.map(boardId => {
        return this.course.courseBoardsByCourseId.nodes.find(courseBoard => {
          return courseBoard.board.id === boardId;
        });
      });
      return boardsInfo.filter(board => {
        return board !== undefined;
      });
    },
    clearData() {
      this.name = null;
      this.description = null;
      this.isEditing = false;
      this.managedEntity = null;
      this.managedEntityType = null;
    },
    toggleModalDisplay() {
      this.showModal = !this.showModal;
    },
    toggleCreationModal(
      entityType: 'group' | 'boardsGroup',
      entity: BoardsGroupModel | GroupModel,
    ) {
      this.clearData();
      this.toggleModalDisplay();
      this.managedEntityType = entityType;
      this.managedEntity = entity;
    },
    toggleEditionModal(
      entityType: 'group' | 'boardsGroup',
      entity: BoardsGroupModel | GroupModel,
    ) {
      this.isEditing = true;
      this.managedEntityType = entityType;

      this.managedEntity = entity;
      this.name = entity.name;
      this.description = entity.description;

      this.toggleModalDisplay();
    },
    async refreshBoardsGroups() {
      await this.$store.dispatch(
        'PULL_BOARDS_GROUPS_BY_COURSE_ID',
        this.course.id,
      );
    },
    async deleteBoardGroupInCourse(boardsGroupId: number) {
      if (confirm('Tem certeza que deseja deletar esse conjunto de grupos?')) {
        await this.$store.dispatch('REMOVE_BOARDS_GROUPS', boardsGroupId);
      }
    },
    async deleteGroup(groupId: number) {
      if (confirm('Tem certeza que deseja deletar esse grupo?')) {
        await this.$store.dispatch('REMOVE_GROUP_FROM_BOARDSGROUP', groupId);
      }
    },
    toggleAddBoardToGroupModal(
      groupId: number | null,
      boardsGroupId: number | null,
    ) {
      this.addBoardToGroup = {
        visible: !this.addBoardToGroup.visible,
        groupId,
        boardsGroupId,
      };
    },
    async createDefaultBoardsGroup() {
      if (this.addDefaultGroupLoading) return;
      this.addDefaultGroupLoading = true;
      const defaultBoardsGroup = defaultBoardGroup();
      try {
        const response = await this.$store.dispatch('CREATE_BOARDS_GROUP', {
          courseId: this.course.id,
          name: defaultBoardsGroup.name,
          description: defaultBoardsGroup.description,
        });

        const boardsGroupId = response.data.createBoardsGroup.id;
        for (const group of defaultBoardsGroup.groups) {
          await this.$store.dispatch('CREATE_GROUP_IN_BOARDSGROUP', {
            boardsGroupId,
            groupInfo: { name: group.name, boardIds: group.boardIds },
          });
        }
      } catch (err) {
        alert(
          `Algo deu errado. Envie essas informações para os desenvolvedores: ${err}`,
        );
      }
      await this.refreshBoardsGroups();
      this.addDefaultGroupLoading = false;
    },
    async deleteCourseBoard(boardId: number) {
      if (
        confirm(
          'Tem certeza que deseja deletar essa disciplina do curso? Ao continuar, ela será removida de todos os grupos que está associada.',
        )
      ) {
        await this.$store.dispatch('DELETE_COURSE_BOARD', boardId);
        await this.$store.dispatch('PULL_COURSE', this.course.id);
      }
    },
  },
});
